export const cloneControl = {
  defaultButton: `Clonar`,
  defaultNoun: `configurações`,
  itemNounDefault: `estas configurações`,
  pullTitle: `Trazer configurações de outro anúncio`,
  pushTitle: `Copiar estas configurações para outro anúncio`,
  pullSubReplace: `Serão aplicadas a este anúncio`,
  pullSubAdd: `Serão adicionadas às existentes neste anúncio`,
  pushSubReplace: `Serão aplicadas às que você escolher`,
  pushSubAdd: `Serão adicionadas às que você escolher`,
  pullTitleFull: `Trazer {noun}`,
  pushTitleFull: `Copiar {noun}`,
  pullSubtitle: `Escolha o anúncio de onde trazer as configurações. Serão aplicadas a este.`,
  pushSubtitle: `Copie estas configurações para os anúncios que você escolher.`,
};
